const createItemsCache = ({items, startFrom, initialLoad, initialItemsPerPage, subsequentItemsPerPage}) => {
    let itemsLength = items.length
    const subsidiseItems = initialLoad && subsequentItemsPerPage > initialItemsPerPage
    const cache = {}
    if (subsidiseItems) {
        cache[startFrom] = items.slice(0, initialItemsPerPage)
        cache[initialItemsPerPage + startFrom] = items.slice(initialItemsPerPage, subsequentItemsPerPage)
        itemsLength -= subsequentItemsPerPage
    }
    for (let i = 0; i < Math.ceil(itemsLength / subsequentItemsPerPage); i += 1) {
        const keyStart = subsidiseItems ? i + 1 : i
        const key = keyStart * subsequentItemsPerPage + startFrom
        cache[key] = items.slice(
            keyStart * subsequentItemsPerPage,
            keyStart * subsequentItemsPerPage + subsequentItemsPerPage,
        )
    }
    return cache
}
export default createItemsCache
